import React, {useCallback, useEffect} from "react";

export const defaultToastDuration = 3;
type duration = number | "auto";

export enum ToastType {
    success = "bg-success",
    error = "bg-danger",
    warning = "bg-warning",
    info = "bg-info"
}

export type ToastParam = {
    message?: string,
    duration?: duration,
    icon?: string,
    type?: ToastType
}

type UiToastType = {
    duration?: duration,
    open: boolean,
    onClose: () => void,
    icon?: string,
    message?: string,
    className?: string,
    toastType?: ToastType,
}

export const UiToast: React.FC<UiToastType> = (
    {
        duration = "auto",
        open,
        onClose,
        icon,
        message,
        className,
        toastType
    }) => {

    const getDuration = useCallback(() => {
        if (duration === "auto") {
            if (message !== undefined) {
                const durationDependingOfTheWordLength = Math.round(message.length / 10);
                return durationDependingOfTheWordLength < defaultToastDuration ? defaultToastDuration : durationDependingOfTheWordLength;
            }
            return defaultToastDuration; // default duration
        }

        return duration;
    }, [duration, message]);
    
    useEffect(() => {
        const timeout = setTimeout(() => {
            onClose();
        }, getDuration() * 1000);
        
        return () => {
            clearTimeout(timeout);
        }
    }, [duration, onClose, getDuration]);

    return (
        <>
            {open && <div
                className={"fixed left-1/2 top-[2%] rounded-xl z-50 h-12 w-auto overflow-hidden min-w-2 " +
                    (className ? ` ${className}`: "") +
                    (toastType ? ` ${toastType}`: ` ${ToastType.success}`)}
                style={{transform: "translate(-50%, 0)"}}
            >
                <div className="flex justify-start items-center h-11">
                    {icon && <img
                        className="w-8 h-6 pl-3"
                        src={`/icons/${icon}.svg`}
                        alt={icon}
                    />
                    }

                    {message && <div className={"px-3 text-nowrap"}>
                        <p>{message}</p>
                    </div>}
                </div>

                <div
                    className={"h-1 bg-transparent-black"}
                    style={{
                        animation: `loading ${getDuration()}s linear`,
                        animationFillMode: "forwards"
                    }}
                />
                
            </div>}
        </>
    )
}
